export default __webpack_public_path__ + "static/media/empty.6c7b0272.png";